const e = {
  name: "Facebook",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 39.9" style="enable-background:new 0 0 40 39.9;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
	.st1{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,10,7.3,18.3,16.9,19.8v-14h-5.1V20h5.1v-4.4c0-5,3-7.8,7.6-7.8c2.2,0,4.5,0.4,4.5,0.4
			v4.9h-2.5c-2.5,0-3.3,1.5-3.3,3.1V20h5.5l-0.9,5.8h-4.7v14C32.7,38.3,40,30,40,20C40,9,31,0,20,0z"/>
		<path class="st1" d="M22.2,39.9c0.1,0,0.1,0,0.2,0C22.3,39.9,22.2,39.9,22.2,39.9L22.2,39.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Facebook
};
